import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from 'prop-types';

export default function ModalArticle(props) {
  return (
    <Modal show={props.isOpen} onHide={props.closeModal} onClose={props.closeModal} backdrop="static" className="article-modal">
      <Modal.Header closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="fw-bold">{props.teaser}</p>
        {props.paragraphs.map((p, index) =>
          <p key={index}>{p}</p>
        )}
      </Modal.Body>
    </Modal>
  )
}

ModalArticle.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  title: PropTypes.string,
  paragraphs: PropTypes.array
}